module.exports = __webpack_public_path__ + "static/img/5.ecc5cf04.png";